import { Link } from "react-router-dom";
import { PUBLIC_ROUTES } from "../../routes";
import MarketingShell from "./MarketingShell";

const GUARANTEES = [
  {
    title: "No network in the hot path",
    body: "The safety loop runs on the robot, not in the cloud, so a dropped link cannot delay a stop. Today it is a Python control loop with the envelope enforced in-process; the native Rust microkernel that takes it under 0.5 ms is on the roadmap, not in your hands yet.",
  },
  {
    title: "Force-limited by configuration",
    body: "Contact force is bounded by the safety envelope you configure per deployment, and a breach triggers an immediate stop. The default threshold is deliberately conservative rather than a fixed published figure — the number that matters is the one commissioned on your cell, and on some controllers force is reported by the vendor rather than by us.",
  },
  {
    title: "Fail-safe fallbacks",
    body: "If cloud latency crosses 20 ms, the robot eases into a defensive-yield posture — and if it is carrying something, lowers it in a controlled safe descent.",
  },
] as const;

export default function ProductEdgeReflex() {
  return (
    <MarketingShell>
      <section className="sg-hero">
        <div className="sg-hero-copy">
          <p className="sg-eyebrow">Pillar C · Edge Reflex Core</p>
          <h1>Deterministic safety, even when the network isn&rsquo;t.</h1>
          <p className="sg-hero-text">
            The Edge Reflex runs on the robot itself: a small control loop
            that enforces impedance, watchdog timing, and fallback flows
            independent of the cloud. Cloud reasoning is welcome — but
            never required for safe behaviour.
          </p>
          <div className="sg-hero-actions">
            <Link to={PUBLIC_ROUTES.signup} className="sg-btn sg-btn-primary">
              Request a pilot
            </Link>
            <Link to={PUBLIC_ROUTES.compliance} className="sg-btn sg-btn-secondary">
              See Compliance
            </Link>
          </div>
        </div>
      </section>

      <section className="sg-pillars">
        <div className="sg-section-heading compact">
          <p className="sg-section-kicker">Guarantees</p>
          <h2>What the kernel will hold to.</h2>
        </div>
        <div className="sg-pillars-grid">
          {GUARANTEES.map((item) => (
            <article className="sg-pillar" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>
    </MarketingShell>
  );
}
